<comment>
「エクステリアを見る」ボタン
</comment>

<template>
  <button @mousedown.stop="" class="extBtn" :class="{positionWithMenu:showGradeList}" @click="gotoExt()"><img src="@/assets/image/btn_ext.png" alt="エクステリアを見る"></button>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'extBtn',
  computed: {
    ...mapState([
      'queryParam',
      'showGradeList',
      'isExtChildWindow'
    ]),
  },
  methods: {
    gotoExt(){
      if (this.queryParam && this.queryParam.grade) {
        window.close();
      }
      setTimeout(function(){
          let queryStr = '';
          if(this.queryParam && this.queryParam.tablet){
            queryStr = '?tablet='+this.queryParam.tablet;
          }
          location.href = '../main.html'+queryStr;
        }, 100);
    }
  },
}
</script>

<style lang="scss" scoped>
.extBtn{
  position: absolute;
  left: 10px;
  bottom: 59+14px;
  appearance: none;
  border: none;
  line-height: 0;
  background: none;
  cursor: pointer;
  width: 178px;
  &.positionWithMenu{
    bottom: 59+171+18px;
  }
  @include size_s{
    bottom: (-16) + 59+14px;
    &.positionWithMenu{
      bottom: (-58) + 59+171+18px;
    }
  }
  img{
    width: 100%;
    position:relative;//bottonクリック時IE11でずれるのを防止
  }
}
</style>